import React, { Component } from 'react';

import { Modal } from 'react-bootstrap';

import ContactForm from './ContactForm';

class ContactModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };
    }

    close() {
        window._paq.push(['trackEvent', 'Modal', 'Close', 'ContactModal'])
        this.setState({showModal: false});
    }

    open() {
        this.setState({
            showModal: true,
            showSuccess: false,
            showError: false
        });

        window._paq.push(['trackEvent', 'Modal', 'Open', 'ContactModal'])
    }

    onSuccessfulSubmit(data) {
        setTimeout(function() {
            this.close();
        }.bind(this), 2000);
    }

    render() {
        return (
            <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>Contact</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ContactForm onSuccessfulSubmit={this.onSuccessfulSubmit.bind(this)} />
                </Modal.Body>
            </Modal>
       );
    }
}

export default ContactModal;



// WEBPACK FOOTER //
// ./src/components/contact/ContactModal.js